import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, GiftIcon } from "lucide-react";
import { BONOS } from "../data/content";
export function Bonos() {
  const [activeIndex, setActiveIndex] = useState(0);
  const totalBonos = BONOS.length;
  const goToBonus = (index: number) => {
    setActiveIndex((index + totalBonos) % totalBonos);
  };
  const handleDragEnd = (_: MouseEvent | TouchEvent | PointerEvent, info: {
    offset: {
      x: number;
    };
  }) => {
    if (info.offset.x < -45) goToBonus(activeIndex + 1);
    if (info.offset.x > 45) goToBonus(activeIndex - 1);
  };
  return <section className="px-5 pt-4" aria-label="Bonos incluidos" data-id="element-25" data-mp="352npark29d1b">
      <div className="mb-5 rounded-2xl border border-green-200 bg-green-50 p-4 text-center" data-id="element-26" data-mp="39496gp3modhb">
        <p className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-wide text-green-700" data-id="element-27" data-mp="1aomqu7sfas1r">
          <GiftIcon size={18} aria-hidden="true" data-id="element-28" data-mp="1eqhqz8ymazdy" />
          Bonos GRATIS solo por hoy
        </p>
        <p className="mt-1 text-xs text-green-700" data-id="element-29" data-mp="3e52jh1ygf1mq">
          Incluidos sin coste adicional si compras el kit hoy
        </p>
      </div>

      <div className="relative" data-id="element-30" data-mp="39b7x1qrgs8jy">
        <div className="overflow-hidden rounded-3xl" data-id="element-31" data-mp="34dofohzgzfns">
          <motion.div className="flex" animate={{
          x: `-${activeIndex * 100}%`
        }} transition={{
          type: "spring",
          stiffness: 320,
          damping: 32
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.12} onDragEnd={handleDragEnd} data-id="element-32" data-mp="34ehij7vb5l0n">
            {BONOS.map(bonus => <article key={bonus.title} className="w-full flex-none" data-id="element-33" data-mp="3n3eah538g1fp">
                <div className="overflow-hidden rounded-3xl border border-blue-100 bg-white p-3 shadow-sm" data-id="element-34" data-mp="3i64dn4diknhu">
                  <div className="overflow-hidden rounded-2xl border border-blue-50 bg-blue-50" data-id="element-35" data-mp="2bpslbjxdhzu6">
                    <img src={bonus.image} alt={`Preview de ${bonus.title}`} className="block h-auto w-full" data-id="element-36" data-mp="26q68hblgillw" />
                  </div>
                  <h3 className="mt-4 text-center text-base font-extrabold leading-snug text-blue-950" data-id="element-37" data-mp="12rapmi6ocz5w">
                    🎁 {bonus.title}
                  </h3>
                  <p className="mt-2 text-center text-xs font-bold uppercase tracking-wide text-green-600" data-id="element-38" data-mp="trnolxhuxvdd">
                    Valor incluido GRATIS por hoy
                  </p>
                </div>
              </article>)}
          </motion.div>
        </div>

        <button type="button" onClick={() => goToBonus(activeIndex - 1)} aria-label="Ver bono anterior" className="absolute left-2 top-[38%] flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-blue-100 bg-white/95 text-blue-700 shadow-sm transition-colors hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2" data-id="element-39" data-mp="jvkm2qj3fupw">
          <ChevronLeftIcon size={19} aria-hidden="true" data-id="element-40" data-mp="3dmazg6afg8he" />
        </button>
        <button type="button" onClick={() => goToBonus(activeIndex + 1)} aria-label="Ver siguiente bono" className="absolute right-2 top-[38%] flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-blue-100 bg-white/95 text-blue-700 shadow-sm transition-colors hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2" data-id="element-41" data-mp="39l8wpfhaxeao">
          <ChevronRightIcon size={19} aria-hidden="true" data-id="element-42" data-mp="3skwna3ukzufu" />
        </button>
      </div>

      <div className="mt-4 flex items-center justify-center gap-2" role="tablist" aria-label="Seleccionar bono" data-id="element-43" data-mp="a6ndbfdr2xm4">
        {BONOS.map((bonus, index) => <button key={bonus.title} type="button" role="tab" aria-selected={activeIndex === index} aria-label={`Ver bono ${index + 1} de ${totalBonos}`} onClick={() => goToBonus(index)} className={`h-2.5 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 ${activeIndex === index ? "w-6 bg-blue-700" : "w-2.5 bg-blue-200 hover:bg-blue-400"}`} data-id="element-44" data-mp="57suidfs9920" data-mpi={index} />)}
      </div>
    </section>;
}